export const fetchDashboardReportURL = () => {
  return `trip/dashboard`;
};

export const fetchTaskManagementDataURL = () => {
  return `trip/task-management`;
};
